export default __webpack_public_path__ + "static/media/plum.73601b11.png";